module.exports = __webpack_public_path__ + "static/media/CloseCourseManagementTray_X.82b09c9a.svg";